import { SubscriptionsEffect } from "./store/effects/subscriptions.effect";
import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
  LOCALE_ID,
} from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
} from "@angular/router";
import { provideFuse } from "@fuse";
import { appRoutes } from "app/app.routes";
import { provideIcons } from "app/core/icons/icons.provider";
import { mockApiServices } from "app/mock-api";
import { RECAPTCHA_V3_SITE_KEY } from "ng-recaptcha-2";
import { environment } from "environments/environment";
import { provideHttpInterceptor } from "./core/interceptors/http.provider";
import { provideEnvironmentNgxMask } from "ngx-mask";
import { provideStoreDevtools } from "@ngrx/store-devtools";
import { provideStore } from "@ngrx/store";
import { metaReducers, reducers } from "./store/reducers";
import { provideEffects } from "@ngrx/effects";
import { UserEffect } from "./store/effects/user.effect";
import { ClientAccountsEffect } from "./store/effects/client-accounts.effect";
import { CompanyEffect } from "./store/effects/company.effects";
import { ContextEffect } from "./store/effects/context.effects";
import { NavigationActionTiming, provideRouterStore } from "@ngrx/router-store";
import { RouterSerializer } from "./store/router/router.serializer";
import {
  CalendarModule,
  DateAdapter as CalendarDateAdapter,
} from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
import { provideMomentDateAdapter } from "@angular/material-moment-adapter";
import { provideTranslation } from "./core/transloco/transloco.provider";
import "moment/locale/fr";
import "moment/locale/ja";
import { registerLocaleData } from "@angular/common";
import localeFr from "@angular/common/locales/fr";
import localeAr from "@angular/common/locales/ar-DZ";
registerLocaleData(localeFr);
registerLocaleData(localeAr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideHttpInterceptor(),
    provideRouter(
      appRoutes,
      withInMemoryScrolling({ scrollPositionRestoration: "enabled" }),
      withComponentInputBinding(),
    ),
    provideStore(reducers, { metaReducers }),
    provideRouterStore({
      serializer: RouterSerializer,
      navigationActionTiming: NavigationActionTiming.PostActivation,
    }),
    provideEffects([
      UserEffect,
      ClientAccountsEffect,
      SubscriptionsEffect,
      CompanyEffect,
      ContextEffect,
    ]),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: !isDevMode(),
    }),
    provideEnvironmentNgxMask(),
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.reCaptcheKey },
    { provide: LOCALE_ID, useValue: "fr-FR" },

    // Moment Date Adapter
    provideMomentDateAdapter({
      parse: {
        dateInput: ["DD/MM/YYYY"],
      },
      display: {
        dateInput: "DD/MM/YYYY",
        monthYearLabel: "MMM YYYY",
        dateA11yLabel: "LL",
        monthYearA11yLabel: "MMMM YYYY",
      },
    }),
    provideTranslation(),
    provideIcons(),
    provideFuse({
      mockApi: {
        delay: 0,
        services: mockApiServices,
      },
      fuse: {
        layout: "dense",
        scheme: "light",
        screens: {
          sm: "600px",
          md: "960px",
          customLg: "1024px",
          lg: "1280px",
          xl: "1440px",
        },
        theme: "theme-default",
        themes: [
          {
            id: "theme-default",
            name: "Default",
          },
        ],
      },
    }),
    importProvidersFrom(
      CalendarModule.forRoot({
        provide: CalendarDateAdapter,
        useFactory: adapterFactory,
      }),
    ),
    provideEnvironmentNgxMask(),
  ],
};
